export enum ProjectType {
  CEMETERY = "CEMETERY",
  FVE_SERVICE = "FVE_SERVICE",
  PARK = "PARK",
  FACILITY = "FACILITY",
  GENERIC = "GENERIC",
  FVE = "FVE",
}
